import { Component, OnInit, Input } from '@angular/core';
import { ReqService } from '@core/services';
import { NgIf } from '@angular/common';
import { MbBadgeModule, MbIconTextModule, MbIconModule } from '@am/moebius';

@Component({
    selector: 'cancel-policies-information',
    templateUrl: './cancel-policies-information.component.html',
    styleUrls: ['./cancel-policies-information.component.scss'],
    standalone: true,
    imports: [
        MbBadgeModule,
        MbIconTextModule,
        MbIconModule,
        NgIf,
    ],
})
export class CancelPoliciesInformationComponent implements OnInit {
  @Input()
  policies: any;
  @Input()
  refundable: boolean;

  public cancelation: any;
  public isCvc: boolean;
  public completelyRefundable: boolean;

  constructor(private reqService: ReqService) {}

  ngOnInit() {
    this.isCvc = this.reqService.isCVC();
    this.cancelation = this.policies[0]?.to;

    this.cancelation = this.incrementCancelationPolice(this.policies[0]?.to, 1);

    this.refundable = !this.isCvc
      ? this.refundable
      : this.policies.some((item) => item.percentage !== 100);
    this.completelyRefundable = !this.isCvc
      ? this.refundable
      : this.policies.some((item) => item.percentage === 100);
  }



incrementCancelationPolice(to: any , dayIncrement:number) {
  const date = new Date(to.year, to.monthNumber - 1, to.date);
  date.setDate(date.getDate() + dayIncrement);

  return {
    date: date.getDate(),
    monthNumber: date.getMonth() + 1,
    year: date.getFullYear(),
    plain: date.toISOString().split('T')[0],
  };
}
}
